import { render, staticRenderFns } from "./LuckyTurntable.vue?vue&type=template&id=0f0d459c&scoped=true&"
import script from "./LuckyTurntable.vue?vue&type=script&lang=js&"
export * from "./LuckyTurntable.vue?vue&type=script&lang=js&"
import style0 from "./LuckyTurntable.vue?vue&type=style&index=0&id=0f0d459c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0d459c",
  null
  
)

export default component.exports